import { SchemaType } from '../utils/type';
import { validateRes } from '../utils/check';
const EventKey = 'CallbackList';
if (process.env.BROWSER) {
    window.XHSEvents = window.XHSEvents || {};
}
// 事件监听回调
const XHSEventsCB = {};
/**
 * 把callback添加到event的监听列表里
 * @param eventName 事件名
 * @param callback 事件监听回调
 */
export function addCalledJsListener(eventName, callback) {
    const eventCBKey = `${eventName}${EventKey}`;
    XHSEventsCB[eventCBKey] = XHSEventsCB[eventCBKey] || [];
    const callbacks = XHSEventsCB[eventCBKey];
    for (let i = 0; i < callbacks.length; i++) {
        if (callbacks[i] === callback) {
            return;
        }
    }
    callbacks.push(callback);
}
/**
 * 收到事件,迭代调用事件对于的callback
 * @param eventName 事件名
 */
export function generateCalledJsCallback(eventName) {
    return (res) => {
        validateRes(eventName, SchemaType.Event, res);
        const callbacks = XHSEventsCB[`${eventName}${EventKey}`] || [];
        callbacks.forEach(cb => cb(res));
    };
}
/**
 * 把指定的callback从监听列表移除
 * @param eventName 需要移除监听的事件名
 * @param callback 移除的监听回调
 */
export function removeCalledJsListener(eventName, callback) {
    return {
        remove() {
            const eventCBKey = `${eventName}${EventKey}`;
            const callbacks = XHSEventsCB[eventCBKey];
            XHSEventsCB[eventCBKey] = callbacks.filter(item => item !== callback);
        },
    };
}
